import { createContext, useContext } from "react";

export const ModalContext = createContext({
  openProspectus: () => {},
  openEnquiry: () => {},
});

export const useModals = () => useContext(ModalContext);
